import React from "react";

import { StyledItemAutoMargin } from "components/base/FitContainers";

import AddNewPrefixesModal from "./Modals/AddNewPrefixesModal/AddNewPrefixesButton";
import AllocatedNumbersModal from "./Modals/AllocateNumbersModal/TrunksAllocation";
import NumbersDownloadDropdown from "../NumbersDownloadDropdown";

const TopBarActions = ({
    isMobile,
    isTransitTrunks,
    isGanTrunks,
    customRangesTrunk,
    account,
    isDownloadInProgress,
    currentDisplay,
    trunk_id,
    handleDownloadNumbersCsv,
    handleDownloadOnlyNumbers,
    showAllocateTrunkButton,
    showAllocatedNumbersModal,
    closeAllocatedNumbersModal,
    currentTrunk,
    service,
    sp_key,
    sp_auth,
    spOtpType,
    updateItems,
    acc_key,
    readonly,
    getTrunks,
    getTrunkNumberCsvById,
    showAddPrefixButton,
    currentSupplier,
    suppliersPrefixDropdownList,
    getSupplierPrefixesDropdown,
}) => {
    return (
        <StyledItemAutoMargin isMobile={isMobile}>
            {!isMobile && ((isTransitTrunks && customRangesTrunk) || (!isTransitTrunks && !isGanTrunks)) &&
                <NumbersDownloadDropdown
                    isTransitTrunks={isTransitTrunks}
                    account={account}
                    loading={isDownloadInProgress}
                    disabled={currentDisplay !== "trunk_number" || !trunk_id || isDownloadInProgress}
                    onDownloadNumbersCsv={handleDownloadNumbersCsv}
                    onDownloadOnlyNumbersCsv={handleDownloadOnlyNumbers}
                />
            }

            {!isTransitTrunks && !isGanTrunks && showAllocateTrunkButton &&
                <AllocatedNumbersModal
                    isMobile={isMobile}
                    account={account}
                    forsed_open={showAllocatedNumbersModal}
                    onClose={closeAllocatedNumbersModal}
                    activeTrunk={currentTrunk}
                    trunk_id={trunk_id}
                    service={service}
                    sp_key={sp_key}
                    sp_auth={sp_auth}
                    spOtpType={spOtpType}
                    update={updateItems}
                    account_id={acc_key}
                    disabled={readonly || (currentTrunk && currentTrunk?.incorporated)}
                    getTrunks={getTrunks}
                    getTrunkNumberCsvById={getTrunkNumberCsvById}
                />
            }

            {customRangesTrunk && isTransitTrunks && showAddPrefixButton &&
                <AddNewPrefixesModal
                    currentTrunk={currentTrunk}
                    supplierId={currentSupplier?.supplier_id}
                    accountId={acc_key}
                    trunkId={trunk_id}
                    isMobile={isMobile}
                    update={() => {
                        getTrunks(true);
                        updateItems();
                    }}
                    disabled={readonly || !currentTrunk}
                    suppliersPrefixDropdownList={suppliersPrefixDropdownList}
                    getSupplierPrefixesDropdown={getSupplierPrefixesDropdown}
                />
            }
        </StyledItemAutoMargin>
    );
};

export default TopBarActions;
